// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1_DR-","options":"AnswerScale_options__EC-Hj","selected":"AnswerScale_selected__OYQJZ"};